<template>
  <div>
    <div class="k2-scrim" @click="$emit('close')"></div>
    <aside ref="sheet" class="k2-sheet" role="dialog" aria-modal="true" :aria-label="label" @keydown="onKeydown">
      <div class="k2-sh-h">
        <slot name="head" />
        <button type="button" class="k2-ib" data-fk="shx" :aria-label="tx('close')" @click="$emit('close')">
          <k2-icon n="mdi-close" :s="22" />
        </button>
      </div>
      <div class="k2-sh-b">
        <slot />
      </div>
    </aside>
  </div>
</template>

<script>
import K2Icon from "./K2Icon.vue";
import kds2Text from "@/mixins/kds2Text";

const FOCUSABLE = 'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Bočni list (na telefonu donji): tamna zavjesa iza, fokus ostaje unutra, a pri zatvaranju se vraća na dugme koje ga je otvorilo.
export default {
  name: "Kds2Sheet",
  components: { K2Icon },
  mixins: [kds2Text],
  props: {
    label: { type: String, default: "" },
    returnEl: { default: null }, // element koji je otvorio list
  },
  mounted() {
    const close = this.$el.querySelector('[data-fk="shx"]');
    if (close) close.focus({ preventScroll: true });
  },
  beforeDestroy() {
    const el = this.returnEl;
    if (el && el.isConnected && el.focus) {
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        // fokus se ne može vratiti
      }
    }
  },
  methods: {
    onKeydown(e) {
      if (e.key !== "Tab") return;
      const items = Array.from(this.$refs.sheet.querySelectorAll(FOCUSABLE)).filter((n) => n.offsetParent !== null);
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },
  },
};
</script>
